import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PRM } from '@reflact/prmacweb';
import { PackService } from '../services/PackService';

export const packContentResolver: ResolveFn<PRM.IpadPackage> = async (route) => {
  const packService = inject(PackService);
  const pack = await packService.getCurrentPackage();
  return pack;
};
